var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg82(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1563 5.87188V4.94375C17.1563 3.9875 16.397 3.22812 15.4407 3.22812H9.19697L9.1126 3.00312C8.91572 2.49687 8.4376 2.1875 7.90322 2.1875H2.22197C1.26572 2.1875 0.506348 2.94688 0.506348 3.90313V14.8438C0.506348 15.8 1.26572 16.5594 2.22197 16.5594H15.8063C16.7626 16.5594 17.522 15.8 17.522 14.8438V6.74375C17.522 6.40625 17.3813 6.09688 17.1563 5.87188ZM15.4407 4.46563C15.6938 4.46563 15.8907 4.6625 15.8907 4.91563V5.45H10.097L9.70322 4.46563H15.4407ZM16.2563 14.8438C16.2563 15.0969 16.0595 15.2937 15.8063 15.2937H2.22197C1.96885 15.2937 1.77197 15.0969 1.77197 14.8438V3.875C1.77197 3.62188 1.96885 3.425 2.22197 3.425L7.93135 3.45312L9.08447 6.32188C9.16885 6.575 9.42197 6.71563 9.6751 6.71563H16.2282C16.2282 6.71563 16.2563 6.71563 16.2563 6.74375V14.8438Z",
    fill: "#4F81BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg82);
export default __webpack_public_path__ + "static/media/svg82.c619f85108cdb5654150415f768af204.svg";
export { ForwardRef as ReactComponent };